import React, { useState } from "react";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useApp } from "@/store";

const cls = "w-full rounded-xl border border-gray-200 px-4 py-2.5 outline-none transition-colors focus:border-[#002FA7] focus:ring-2 focus:ring-[#002FA7]/20";

export default function Contact() {
  const { t, user } = useApp();
  const [f, setF] = useState({ name: user?.company_name || user?.name || "", email: user?.email || "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/contact", f); setSent(true); toast.success(t("contact_sent")); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="mx-auto max-w-xl px-5 py-14 sm:px-8" data-testid="contact-page">
      <div className="flex items-center gap-2 text-[#002FA7]"><Mail size={22} /><span className="text-xs font-bold uppercase tracking-[0.2em]">{t("contact")}</span></div>
      <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">{t("contact_title")}</h1>
      <p className="mt-3 text-gray-500">{t("contact_sub")}</p>
      {sent ? (
        <div data-testid="contact-success" className="mt-8 rounded-2xl bg-[#155724]/10 p-6 font-semibold text-[#155724]">{t("contact_sent")}</div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-3" data-testid="contact-form">
          <input data-testid="contact-name" required value={f.name} onChange={(e) => set("name", e.target.value)} placeholder={t("your_name")} className={cls} />
          <input data-testid="contact-email" required type="email" value={f.email} onChange={(e) => set("email", e.target.value)} placeholder={t("your_email")} className={cls} />
          <input data-testid="contact-subject" required value={f.subject} onChange={(e) => set("subject", e.target.value)} placeholder={t("subject")} className={cls} />
          <textarea data-testid="contact-message" required minLength={10} rows={5} value={f.message} onChange={(e) => set("message", e.target.value)} placeholder={t("message")} className={cls} />
          <button data-testid="contact-submit" disabled={busy} className="inline-flex items-center gap-2 rounded-full bg-[#002FA7] px-6 py-3 text-sm font-bold text-white disabled:opacity-60">{busy && <Loader2 size={15} className="animate-spin" />} {t("send")}</button>
        </form>
      )}
    </div>
  );
}
